import {
  Button,
  Center,
  Divider,
  Heading,
  HStack,
  Text,
  VStack,
  Modal,
  Select,
} from "native-base";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { connect } from "react-redux";
import { useDispatch, useSelector } from "react-redux";
import { isLoaded, useFirestoreConnect } from "react-redux-firebase";
import { useHistory } from "react-router-dom";
import { compose } from "redux";
import { Redirect } from "react-router-dom";
import { setNotifySound, SetOrderStatus, RefundUserOrder } from "../Redux/actions";
import Joyride, { STATUS } from "react-joyride";
import { useSetState } from "react-use";
import RaiseConcernModal from "./RaiseConcernModal";
import OrderCard from "../components/OrderCard";
import { usePagination } from "../hooks/pagination.hook";
import { mergeOrders, isActiveOrder, isCompletedOrder } from "../utils/orderDisplay";

const Orders = (props) => {
  const history = useHistory();
  const id = props.match.params.id;
  const { auth } = props;

  const [showModal, setShowModal] = React.useState(false);
  const [raiseModel, setRaiseModel] = React.useState(false);
  const [selectedOrder, setSelectedOrder] = React.useState(null);

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [otherPage, setOtherPage] = useState(0);
  const [otherRowPerPage, setOtherRowPerPage] = useState(5);

  useEffect(() => { document.title = "Orders | Piatto"; }, []);

  const dispatch = useDispatch();
  const isFirstLogin = useSelector(
    ({ state: { isFirstLogin } }) => isFirstLogin
  );

  useEffect(() => {
    if (isFirstLogin) {
      handleClickStart();
    }
  }, [isFirstLogin]);

  const handleClickStart = (event) => {
    setState2({
      run: true,
    });
  };
  const [{ run, steps2 }, setState2] = useSetState({
    run: false,
    steps2: [
      {
        content:
          "This is the table number or location where the order was submitted from, where the customer would like to receive and enjoy their order. Remember 101 is front entrance way.",
        target: ".routeD",
        // disableBeacon: true,
      },
      {
        content:
          "This is the name of the dish being ordered, as it is displayed in Piatto.",
        target: ".routeE",
      },
      {
        content:
          "These are all the options that were selected for the dish, including the necessary decisions.",
        target: ".routeF",
      },
      {
        content: "This is the first name of the customer who placed the order.",
        target: ".routeG",
      },
      {
        content:
          "This column indicates whether the order is a Dine-In or Takeaway order.",
        target: ".routeH",
      },
      {
        content:
          "This column indicates the accessibility needs of the customer, whether they are in a wheelchair, deaf, blind or require a sensory minimal location to enjoy their order. Please be mindful of this and accomodate, such that if your venue is up-stairs and the customer has indicated they are in a wheelchair, please consider taking the order to the bottom of the stairs. If the customer has indicated that they are deaf, please consider that shouting their first name when their order is complete would not be sufficient. If the customer has indicated that they are blind, please kindly show them to a table or deliver their order to them, saying their name, checking you have their attention and kindly placing the order in their hand. If the customer has indicated that they require a sensory minimal location to enjoy their order, please be alert for this customer, kindly show them to a table or deliver their order to them, saying their name, checking you have their attention and kindly offering the order for them to take out of your hand.",
        target: ".routeI",
      },
      {
        content:
          "This column will indicate the registration number of the car being driven by the customer. If your venue is near to the road or a underground carpark and the customer as indicated an accessibility requirement, please consider bringing their takeaway order to their car.",
        target: ".routeJ",
      },
      {
        content:
          "This column will displayed the charge that was applied to the customer for this order. If anything looks out of the ordinary, please tap the Raise Concerns button on this order and submit a query to Piatto.",
        target: ".routeK",
      },
    ],
  });
  const handleJoyrideCallback = (data) => {
    const { status, type } = data;
    const finishedStatuses = [STATUS.FINISHED, STATUS.SKIPPED];
    if (finishedStatuses.includes(status)) {
      setState2({ run: false });
    }
    if (status === "finished") {
      dispatch({ type: "ISFIRSTLOGIN", payload: false });
    }
  };
  useFirestoreConnect([
    {
      collection: "Orders",
      where: [["bizId", "==", `${id}`]],
      orderBy: [["timestamp", "asc"]],
    },
  ]);

  const Orders = useSelector(({ firestore: { ordered } }) => ordered.Orders);

  // POS-integrated orders (Square etc.) are saved by newFunctions to the
  // lowercase `orders` collection, keyed by businessId = Business doc ID.
  // Read-only here: they are merged for display, never copied or written.
  const integratedOrdersKey = `integratedOrders_${id}`;
  useFirestoreConnect([
    {
      collection: "orders",
      where: [["businessId", "==", `${id}`]],
      storeAs: integratedOrdersKey,
    },
  ]);
  const IntegratedOrders = useSelector(
    ({ firestore: { ordered } }) => ordered[integratedOrdersKey]
  );

  // One list, both formats mapped to the same display shape, sorted by time.
  const allOrders = useMemo(
    () => mergeOrders(Orders, IntegratedOrders),
    [Orders, IntegratedOrders]
  );
  const completedOrders = allOrders.filter(isCompletedOrder);
  const otherOrders = allOrders.filter(isActiveOrder);

  const paginatedOrders = completedOrders.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  const totalPages = Math.ceil(completedOrders.length / rowsPerPage);

  const otherPaginatedOrder = otherOrders.slice(
    otherPage * otherRowPerPage,
    otherPage * otherRowPerPage + otherRowPerPage
  );

  const otherPages = Math.ceil(otherOrders.length / otherRowPerPage);

  useFirestoreConnect([
    {
      collection: "Business",
      doc: id,
      storeAs: "currentBusiness",
    },
  ]);
  const SingleBusiness = useSelector(
    ({ firestore: { data } }) => data.currentBusiness
  );

  // React.useEffect(() => {
  //   if (Orders && Orders.length > 0) {
  //     const activeOrder = Orders.find(order => order.OrderStatus !== "completed");
  //     if (activeOrder) {
  //       console.log(activeOrder, 'activeOrder------')
  //       setCurrentOrder(activeOrder.userId);
  //     }
  //   }
  // }, [Orders]);
  // console.log(currentOrder, 'currentOrder------')
  // User data is looked up per-order from the order document itself.
  // Previously this loaded the entire Users collection which fails for non-admin users.
  const userData = null;

  // Last seen count per collection. Each source's first load only records its
  // count, so a late-arriving collection doesn't sound as if it were new orders.
  const seenCountsRef = useRef({});

  useEffect(() => {
    const sources = { legacy: Orders, integrated: IntegratedOrders };
    let increased = false;
    Object.entries(sources).forEach(([source, list]) => {
      if (!isLoaded(list)) return;
      const len = list?.length || 0;
      const prev = seenCountsRef.current[source];
      if (prev !== undefined && len > prev) increased = true;
      seenCountsRef.current[source] = len;
    });
    if (increased) {
      // Only notify when NEW orders arrive (count increases)
      dispatch(setNotifySound(true));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [Orders, IntegratedOrders]);

  const bizData = SingleBusiness || null;

  if (!auth.uid) return <Redirect to="/" />;
  return (
      <VStack
        role="main"
        flex="1"
        _light={{ bg: "white" }}
        _dark={{ bg: "coolGray.800" }}
        space="3"
        justifyContent="space-between"
      >
        <Center w={"100%"}>
          <Text color={"white"} position={"absolute"} zIndex={99999} top={-50}>
            {bizData?.bizName || ""}
          </Text>

          <HStack alignSelf={"stretch"}>
            <Button onPress={() => history.push(`/Manage/${id}`)} flex={1}>
              Menu Management
            </Button>
            <Button
              flex={1}
              onPress={() => history.push(`/reservations/${id}`)}
              colorScheme={"orange"}
            >
              Reservation Management
            </Button>
            <Button
              onPress={() => history.push(`/Bussiness/${id}`)}
              flex={1}
              colorScheme={"green"}
            >
              Bussines Management
            </Button>
          </HStack>

          <VStack alignContent={"center"} w={"100%"} alignSelf={"stretch"}>
            <VStack w={"100%"}>
              <Heading alignSelf={"center"}>Orders</Heading>
              <Modal isOpen={showModal} onClose={() => setShowModal(false)}>
                <Modal.Content maxWidth="400px">
                  <Modal.Body>
                    <Text
                      style={{
                        fontFamily: "Atkinson Hyperlegible Next, sans-serif",
                        fontSize: "18px",
                      }}
                      textAlign={"center"}
                    >
                      Are you sure you want to cancel this order? Cancelling
                      will not refund the user but will notify them that their
                      order has been cancelled
                    </Text>
                  </Modal.Body>
                  <Modal.Footer
                    display={"flex"}
                    alignItems={"center"}
                    justifyContent={"center"}
                  >
                    <Button.Group space={2}>
                      <Button
                        variant="ghost"
                        colorScheme="blueGray"
                        onPress={() => {
                          setShowModal(false);
                        }}
                      >
                        No, Exit
                      </Button>
                      <Button
                        onPress={() => {
                          setShowModal(false);
                          if (selectedOrder) {
                            dispatch(
                              SetOrderStatus(
                                selectedOrder,
                                "CANCELLED",
                                auth.stsTokenManager.accessToken,
                                bizData?.bizName || ""
                              )
                            );
                          }
                        }}
                      >
                        Yes, Cancel
                      </Button>
                      <Button
                        onPress={() => {
                          setShowModal(false);
                          if (selectedOrder) {
                            dispatch(
                              RefundUserOrder(
                                selectedOrder,
                                id,
                                bizData?.bizName || "",
                                auth.stsTokenManager.accessToken
                              )
                            );
                          }
                        }}
                        colorScheme={"red"}
                      >
                        Refund
                      </Button>
                    </Button.Group>
                  </Modal.Footer>
                </Modal.Content>
              </Modal>

              <VStack space={3} w={"100%"} alignItems={"center"}>
                <>
                  <Joyride
                    callback={handleJoyrideCallback}
                    continuous
                    run={run}
                    scrollToFirstStep
                    showProgress
                    showSkipButton
                    steps={steps2}
                    styles={{
                      options: {
                        zIndex: 10000,
                      },
                    }}
                  />
                  {otherOrders.length === 0 && (
                    <Text color="coolGray.600" py={4}>No active orders</Text>
                  )}
                  {otherPaginatedOrder.map((item) => (
                      <OrderCard
                        key={item.key}
                        order={item}
                        userData={userData}
                        onSetStatus={(order, status) =>
                          dispatch(
                            SetOrderStatus(
                              order,
                              status,
                              auth.stsTokenManager.accessToken,
                              bizData?.bizName || ""
                            )
                          )
                        }
                        onCancel={(item) => { setSelectedOrder(item); setShowModal(true); }}
                        onRaiseConcern={() => setRaiseModel(true)}
                      />
                  ))}

                  <HStack mt={4} mb={6} space={4} alignItems="center">
                    <Button
                      isDisabled={otherPage === 0}
                      onPress={() => setOtherPage((prev) => Math.max(prev - 1, 0))}
                    >
                      Previous
                    </Button>

                    <Text>
                      Page {otherPage + 1} of {otherPages}
                    </Text>

                    <Button
                      isDisabled={page >= otherPages - 1}
                      onPress={() =>
                        setOtherPage((prev) => Math.min(prev + 1, otherPages - 1))
                      }
                    >
                      Next
                    </Button>

                    <Select
                      selectedValue={String(otherRowPerPage)}
                      minWidth="120"
                      accessibilityLabel="Rows per page"
                      placeholder="Rows per page"
                      onValueChange={(val) => {
                        setOtherRowPerPage(Number(val));
                        setOtherPage(0); // Reset page to 0 when rows per page changes
                      }}
                    >
                      {[5, 10, 15, 20].map((value) => (
                        <Select.Item
                          key={value}
                          label={`${value} rows`}
                          value={String(value)}
                        />
                      ))}
                    </Select>
                  </HStack>
                </>
              </VStack>
            </VStack>
            <Divider
              thickness="6"
              bg="coolGray.500"
              ml={2}
              mr={2}
              orientation="horizontal"
            />
            <VStack w={"100%"}>
              <Heading alignSelf={"center"}>Completed</Heading>
              <VStack space={3} w={"100%"} alignItems={"center"}>
                <>
                  {paginatedOrders.map((item) => (
                      <OrderCard
                        key={item.key}
                        order={item}
                        userData={userData}
                        onSetStatus={(order, status) =>
                          dispatch(
                            SetOrderStatus(
                              order,
                              status,
                              auth.stsTokenManager.accessToken,
                              bizData?.bizName || ""
                            )
                          )
                        }
                        onCancel={(item) => { setSelectedOrder(item); setShowModal(true); }}
                        onRaiseConcern={() => setRaiseModel(true)}
                      />
                  ))}
                  <HStack mt={4} mb={6} space={4} alignItems="center">
                    <Button
                      isDisabled={page === 0}
                      onPress={() => setPage((prev) => Math.max(prev - 1, 0))}
                    >
                      Previous
                    </Button>

                    <Text>
                      Page {page + 1} of {totalPages}
                    </Text>

                    <Button
                      isDisabled={page >= totalPages - 1}
                      onPress={() =>
                        setPage((prev) => Math.min(prev + 1, totalPages - 1))
                      }
                    >
                      Next
                    </Button>

                    <Select
                      selectedValue={String(rowsPerPage)}
                      minWidth="120"
                      accessibilityLabel="Rows per page"
                      placeholder="Rows per page"
                      onValueChange={(val) => {
                        setRowsPerPage(Number(val));
                        setPage(0); // Reset page to 0 when rows per page changes
                      }}
                    >
                      {[5, 10, 15, 20].map((value) => (
                        <Select.Item
                          key={value}
                          label={`${value} rows`}
                          value={String(value)}
                        />
                      ))}
                    </Select>
                  </HStack>
                </>
              </VStack>
            </VStack>
            <RaiseConcernModal
              raiseModel={raiseModel}
              setRaiseModel={setRaiseModel}
            />
          </VStack>
        </Center>
      </VStack>
    );
};

const mapStateToProps = (state) => {
  return {
    auth: state.firebase.auth,
  };
};

export default compose(connect(mapStateToProps))(Orders);
